import { useEffect, useState } from 'react';
import { Textarea } from '../../../shared/components/Textarea';
import { Bond, mensagemDeErro } from '../api';
import { useCancelarVinculo } from '../hooks';
import { PessoasModal } from './PessoasModal';

interface Props {
  bond: Bond | null;
  onClose: () => void;
  onSaved: (message: string) => void;
}

export function CancelBondModal({ bond, onClose, onSaved }: Props) {
  const cancelar = useCancelarVinculo();
  const [justification, setJustification] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setJustification('');
    setError(null);
  }, [bond]);

  async function submit() {
    if (!bond) return;
    if (!justification.trim()) return setError('Justificativa é obrigatória.');
    try {
      await cancelar.mutateAsync({ id: bond.id, justification: justification.trim() });
      onSaved('Contratação cancelada.');
    } catch (err) {
      setError(mensagemDeErro(err, 'Não foi possível cancelar a contratação.'));
    }
  }

  return (
    <PessoasModal
      open={bond !== null}
      title="Cancelar contratação?"
      description="O vínculo é encerrado e não pode ser reativado. Uma nova contratação cria outro vínculo."
      submitLabel="Cancelar contratação"
      submitVariant="danger"
      isSubmitting={cancelar.isPending}
      submitError={error}
      onClose={onClose}
      onSubmit={submit}
    >
      <Textarea label="Justificativa" value={justification} onChange={(e) => setJustification(e.target.value)} />
    </PessoasModal>
  );
}
